<template>
  <div class="modal fade" id="subscribe" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h2>Suscribite a Andalepide</h2>
        <p class="size-16">¿Estás listo para recibir a diario el menú más variado de comidas de tu ciudad?<br/>Completa este formulario y un representante nuestro se contactará con vos.</p>
        <form class="form modal-form">
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Nombre y Apellido</label>
                <input type="text" v-model="dataForm.fullName" class="form-control"/>
                <span class="label label-danger" v-if="!$v.dataForm.fullName.required && mostrarErrores">Campo requerido.</span>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Empresa</label>
                <input type="text" v-model="dataForm.empresa" class="form-control"/>
                <span class="label label-danger" v-if="!$v.dataForm.empresa.required && mostrarErrores">Campo requerido.</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>N° de Empleados</label>
                <input type="number" v-model="dataForm.empleados" class="form-control"/>
                <span class="label label-danger" v-if="!$v.dataForm.empleados.required && mostrarErrores">Campo requerido.</span>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Barrio o Zona</label>
                <input type="text" v-model="dataForm.barrio" class="form-control"/>
                <span class="label label-danger" v-if="!$v.dataForm.barrio.required && mostrarErrores">Campo requerido.</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>E-Mail</label>
                <input type="mail" v-model="dataForm.email" class="form-control"/>
                <span class="label label-danger" v-if="(!$v.dataForm.email.required || !$v.dataForm.email.email) && mostrarErrores">Formato no válido.</span>
              </div>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="form-group">
                <label>Teléfono</label>
                <input type="text" v-model="dataForm.telefono" class="form-control"/>
                <span class="label label-danger" v-if="!$v.dataForm.telefono.required && mostrarErrores">Campo requerido.</span>
              </div>
            </div>
          </div>
          <div class="row text-center center-block">
            <vue-recaptcha 
              sitekey="6LfZAikUAAAAAOU_SNuSQG_-dF2mOiHV4XHqrpaF"
              @verify="onVerify"
            >
            </vue-recaptcha>
          </div>
          <div class="form-action">
            <router-link to="/login" class="btn-link deco-dotted pull-left">¿Ya tienes una cuenta?</router-link>
            <button type="button" class="btn btn-fill" @click.prevent="clickEnviar">ENVIAR</button>
          </div>
        </form>
        </div>
      </div>
    </div>
  </div><!-- Fin modal suscribe-->
</template>
<script>
import VueRecaptcha from 'vue-recaptcha'
import $ from 'jquery'
import {email, required, numeric} from 'vuelidate/lib/validators'

export default {
  components: {
    VueRecaptcha
  },
  data () {
    return {
      mostrarErrores: false,
      dataForm: {
        fullName: '',
        empresa: '',
        empleados: 1,
        barrio: '',
        email: '',
        telefono: '',
        respuestaCaptcha: null
      }
    }
  },
  validations: {
    dataForm: {
      fullName: {
        required
      },
      empresa: {
        required
      },
      empleados: {
        numeric,
        required
      },
      barrio: {
        required
      },
      email: {
        email,
        required
      },
      telefono: {
        required
      }
    }
  },
  methods: {
    clickEnviar () {
      const me = this
      if (me.$v.dataForm.$invalid) {
        me.mostrarErrores = true
        return false
      }
      me.$http.post('/api/public/suscribe', me.dataForm).then(({body}) => {
        $('#subscribe').modal('hide')
        me.$emit('mostrar-notificacion', 'El mail se envió correctamente', 'success')
      }, (err) => {
        console.error(err)
      })
    },
    onVerify (res) {
      this.dataForm.respuestaCaptcha = res
    }
  },
  beforeRoute (to, from, next) {
    $('#subscribe').modal('hide')
    next()
  }
}
</script>



// WEBPACK FOOTER //
// ModalSuscribe.vue?5223208e